import React, { useState } from "react";
import { Button, Flex, Form, message } from "antd";
import "./ProductComp.scss";
import NormalButton from "../../../Reuseable/NormalButton/NormalButton";
import CustomSelect from "../../../Reuseable/Select/Select";
import InputField from "../../../Reuseable/InputField/InputField";
import { createProducts } from "../../../assets/api/agency";
import { useSelector } from "react-redux";
import CustomNotification from "../../../Reuseable/CustomNotification/CustomNotification";

const ProductList = ({ products, productsLoading, banks, banksLoading }) => {
  const [form] = Form.useForm();
  const token = useSelector((state) => state.auth.token);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const payload = {
        portfolio: values.companyName,
        product: values.productKey,
      };
      const response = await createProducts(payload, token);
      CustomNotification.show(response?.message, "success");
      setLoading(false);
      form.resetFields();
    } catch (error) {
      CustomNotification.show(error.message, "error");

      setLoading(false);
    }
  };

  return (
    <div className="productFormContainer">
      <h3 className="formTitle">Product List</h3>
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        className="productForm"
      >
        <Flex className="formFlexFirst">
          <Form.Item
            label="Bank Name"
            name="companyName"
            className="formItem"
            required={false}
            rules={[{ required: true, message: "Bank Name is required" }]}
          >
            <CustomSelect
              placeholder="Select Bank Name"
              className="formSelect"
              style={{ minWidth: 200 }}
              options={banks?.map((bank, bankIndex) => ({
                label: bank?.name,
                value: bank?.id,
              }))}
            />
          </Form.Item>

          <Form.Item
            label="Product"
            name="productKey"
            className="formItem"
            required={false}
            rules={[{ required: true, message: "Product is required" }]}
          >
            <CustomSelect
              placeholder="Select Product Key"
              className="formSelect"
              style={{ minWidth: 200 }}
              options={products?.map((product, productIndex) => ({
                label: product?.products,
                value: product?.id,
              }))}
            />
          </Form.Item>
        </Flex>

        <Flex className="formFlexSecond">
          <Form.Item className="formItem">
            <NormalButton
              type="primary"
              htmlType="submit"
              className="submitBtn"
              loading={loading}
            >
              Submit
            </NormalButton>
          </Form.Item>
        </Flex>
      </Form>
    </div>
  );
};

export default ProductList;
